module.exports = __webpack_public_path__ + "img/20180815_150609_101.d4fe8211.jpg";